"use client";

import { useEffect, useRef, useState } from "react";

type ScriptItem =
  | { kind: "them"; text: string; delay: number }
  | { kind: "bot"; text: string; delay: number }
  | { kind: "typing"; delay: number }
  | { kind: "card"; delay: number }
  | { kind: "order"; delay: number };

const HERO_SCRIPT: ScriptItem[] = [
  { kind: "them", text: "สวัสดีค่า ครีมตัวนี้เหมาะกับผิวแพ้ง่ายมั้ยคะ?", delay: 1200 },
  { kind: "typing", delay: 1400 },
  { kind: "bot", text: "เหมาะค่ะ 🌿 สูตรนี้ปราศจากแอลกอฮอล์ พาราเบน ผ่านการทดสอบในผู้ที่มีผิวแพ้ง่าย 96% บอกว่าใช้แล้วไม่ระคายเคืองค่ะ", delay: 2200 },
  { kind: "card", delay: 1500 },
  { kind: "them", text: "เอา 2 กระปุกค่ะ ส่งเก็บปลายทางได้มั้ย", delay: 1600 },
  { kind: "typing", delay: 1100 },
  { kind: "bot", text: "ได้เลยค่ะ ✅ ขอชื่อ-ที่อยู่และเบอร์โทรนะคะ จะออกใบสั่งซื้อให้เลยค่ะ", delay: 2400 },
  { kind: "order", delay: 2200 },
];

export default function HeroChat() {
  const [step, setStep] = useState(0);
  const bodyRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const t = setTimeout(() => {
      setStep((s) => (s + 1) % (HERO_SCRIPT.length + 1));
    }, HERO_SCRIPT[step % HERO_SCRIPT.length]?.delay ?? 1500);
    return () => clearTimeout(t);
  }, [step]);

  const realStep = step % (HERO_SCRIPT.length + 1);
  const visible = HERO_SCRIPT.slice(0, realStep);
  const items = visible.filter((m, i) => !(m.kind === "typing" && i < visible.length - 1));

  useEffect(() => {
    if (bodyRef.current) bodyRef.current.scrollTop = bodyRef.current.scrollHeight;
  }, [realStep]);

  return (
    <div className="chat-body" ref={bodyRef}>
      {items.map((m, i) => {
        const key = `${realStep}-${i}`;
        if (m.kind === "them") {
          return <div key={key} className="msg them anim-in">{m.text}</div>;
        }
        if (m.kind === "bot") {
          return (
            <div key={key} className="msg bot anim-in">
              <span className="lbl">FlowCloser AI</span>
              {m.text}
            </div>
          );
        }
        if (m.kind === "typing") {
          return (
            <div key={key} className="typing anim-in">
              <i></i><i></i><i></i>
            </div>
          );
        }
        if (m.kind === "card") {
          return (
            <div key={key} className="msg-card anim-in">
              <div className="ph">[ product shot ]</div>
              <div className="nm">Calm Repair Cream 50g</div>
              <div className="pr">
                ฿ 690{" "}
                <span style={{ color: "#94a3b8", fontWeight: 500, fontSize: 11, marginLeft: 6, textDecoration: "line-through" }}>
                  ฿ 890
                </span>
              </div>
            </div>
          );
        }
        if (m.kind === "order") {
          return (
            <div
              key={key}
              className="msg bot anim-in"
              style={{ background: "linear-gradient(135deg,#16a34a,#22c55e)" }}
            >
              <span className="lbl">✓ ออเดอร์ #FC-20410 พร้อมส่ง</span>
              ยอดรวม ฿1,380 · เก็บปลายทาง Kerry ค่ะ 🎉
            </div>
          );
        }
        return null;
      })}
    </div>
  );
}
